

const getPuntoVenta = state => state.puntoVenta;



export default {
  getPuntoVenta
};



// WEBPACK FOOTER //
// ./src/store/modules/punto/getters.js